import { createContext, useContext } from 'react';

type ColorContextType = {
  color: string;
  setColor: (color: string) => void;
};

// Default CAD render color — brand teal (#56B6C6) so models pop against
// the cream canvas while staying within the brand palette.
export const DEFAULT_CAD_COLOR = '#56B6C6';

export const ColorContext = createContext<ColorContextType>({
  color: DEFAULT_CAD_COLOR,
  setColor: () => {},
});

export const useColor = () => {
  const context = useContext(ColorContext);
  if (!context) {
    throw new Error('useColor must be used within a ColorProvider');
  }
  return context;
};
